import { Currency, TMoney, FilterOption, Pagination } from 'src/types'
import { FiChevronLeft, FiChevronRight } from 'react-icons/fi';
import defaultHeroImage from 'public/images/collection_default.jpg';
import { Image } from 'src/types';

export const VERCEL_ENV = process.env.NEXT_PUBLIC_VERCEL_ENV

export const MasterCurrency: Currency = 'SGD'
export const PAYNOW_CURRENCY: Currency = 'SGD'
export const GRABPAY_CURRENCIES: Currency[] = ['SGD', 'MYR']

export const CardExpDateFormat = 'MM/YYYY'
export const UIDateFormat = 'DD MMM YYYY'
export const UIMonthFormat = 'MMM YYYY'
export const DBDateFormat = 'YYYY-MM-DD'
export const UITimeFormat = 'hh:mmA'
export const DBTimeFormat = 'HH:mm'
export const UIDateTimeFormat = 'DD MMM YYYY, HH:mm'
export const DEFAULT_IMAGE = '/images/default.jpeg'
export const YOUTUBE_ID_REGEX = /^[A-Za-z0-9_-]{11}$/;
export const LOCALE_DATE_FORMAT: Record<string, Record<string, string>> = {
  default: {
    CardExpDateFormat,
    UIDateFormat,
    UIMonthFormat,
    UITimeFormat,
    UIDateTimeFormat,
  },
  en: {
    CardExpDateFormat,
    UIDateFormat,
    UIMonthFormat,
    UITimeFormat,
    UIDateTimeFormat,
  },
  id: {
    CardExpDateFormat,
    UIDateFormat,
    UIMonthFormat,
    UITimeFormat,
    UIDateTimeFormat,
  },
  ms: {
    CardExpDateFormat,
    UIDateFormat,
    UIMonthFormat,
    UITimeFormat,
    UIDateTimeFormat,
  },
  de: {
    CardExpDateFormat,
    UIDateFormat,
    UIMonthFormat,
    UITimeFormat,
    UIDateTimeFormat,
  },
  nl: {
    CardExpDateFormat,
    UIDateFormat,
    UIMonthFormat,
    UITimeFormat,
    UIDateTimeFormat,
  },
  zh: {
    CardExpDateFormat,
    UIDateFormat: 'YYYY年M月D日',
    UIMonthFormat: 'MMMM YYYY',
    UITimeFormat,
    UIDateTimeFormat: 'YYYY年M月D日 HH:mm',
  },
};


export const commonCarouselSettings = {
  dots: false,
  infinite: false,
  autoplay: false,
  arrows: true,
  prevArrow: (
    <div className="slick-prev">
      <FiChevronLeft strokeWidth={2} />
    </div>
  ),
  nextArrow: (
    <div className="slick-next">
      <FiChevronRight strokeWidth={2} />
    </div>
  )
};

export const RECAPTCHA_KEY = 'g-recaptcha-response'
export const ZERO_AMOUNT: TMoney = {
  amount: 0,
  currency: 'SGD'
}

export const BLOG_KIND_VALUES: { [key: string]: number } = {
  quick_read: 0,
  complete_guide: 1,
  itinerary: 2,
  list: 3,
  tried_and_tested: 4,
  video: 5
}

export const REFERRAL_AMOUNT: TMoney = {
  amount: 10,
  currency: 'SGD'
}

export const REFERRAL_PAYOUT_AMOUNT: TMoney = {
  amount: 10,
  currency: 'SGD'
}

export const SORT_OPTIONS: FilterOption[] = [
  { label: 'recommended', value: 'recommended' },
  { label: 'top_rated', value: 'most_popular' },
  { label: 'price_low_to_high', value: 'asc' },
  { label: 'price_high_to_low', value: 'desc' },
  { label: 'recently_added', value: 'latest' },
];

export const TIME_OF_DAY_OPTIONS: FilterOption[] = [
  { label: 'morning', value: 'morning', desc: 'start_before_12pm' },
  { label: 'afternoon', value: 'afternoon', desc: 'start_after_12pm' },
  { label: 'evening', value: 'evening', desc: 'start_after_5pm' },
];

export const CHILD_AGE_OPTIONS: FilterOption[] = [
  { label: '0_3_years', value: '0_3' },
  { label: '4_7_years', value: '4_7' },
  { label: '8_12_years', value: '8_12' },
];

export const TRIP_TYPE_OPTIONS: FilterOption[] = [
  { label: 'private_trip', value: 'private' },
  { label: 'join_in_trip', value: 'join_in' },
];

export const badgeKinds: { [key: string]: string } = {
  wildlifeSafe: 'wildlife_safe',
  litterFreeLeaveNoTrace: 'litter_free_leave_no_trace',
  lowCarbon: 'low_carbon',
  refusePlastics: 'refuse_plastics',
  communityBased: 'community_based',
  womenOwned: 'women_owned',
};

export const VIMEO_UNSUPPORTED_COUNTRIES = ['ID']

export const DefaultCollectionHeroImage: Image = {
  id: 0,
  name: 'default',
  contentType: 'image/jpg',
  caption: undefined,
  url: defaultHeroImage.src,
  lgUrl: defaultHeroImage.src,
  mdUrl: defaultHeroImage.src,
  webpXlUrl: defaultHeroImage.src,
  webpLgUrl: defaultHeroImage.src,
  webpMdUrl: defaultHeroImage.src,
  webpSmUrl: defaultHeroImage.src
};

export const DEFAULT_PAGINATION: Pagination = {
  currentPage: 1,
  totalPages: 1,
  prevPage: 0,
  nextPage: 0,
  isFirstPage: true,
  isLastPage: false,
  totalCount: 0,
  limitValue: 1,
  offset: 0
}

export const ALPHABET_MAP: { [key: string | number]: string } = {
  0: 'A',
  1: 'B',
  2: 'C',
  3: 'D',
  4: 'E',
  5: 'F',
  6: 'G',
  7: 'H',
  8: 'I',
  9: 'J',
  10: 'K',
  11: 'L',
  12: 'M',
  13: 'N',
  14: 'O',
  15: 'P',
  16: 'Q',
  17: 'R',
  18: 'S',
  19: 'T',
  20: 'U',
  21: 'V',
  22: 'W',
  23: 'X',
  24: 'Y',
  25: 'Z'
}


export const SUPPORTED_LOCALES = ['en', 'id', 'ms', 'zh', 'de', 'nl'];
export const HEADER_HEIGHT = 72
export const BUFFER_LINE_HEIGHT = 2

export const CONVERSION_FEE_RATE = 0.035
export const CONVERSION_FEE_MULTIPLIER = (CONVERSION_FEE_RATE + 1)

export const STRIPE_ACCOUNT_COUNTRY_CODE = 'SG'

export const STRIPE_FRIENDLY_ERROR_MESSAGES: { [key: string]: string | undefined } = {
  payment_intent_authentication_failure: 'The provided payment method has failed authentication',
  undefined: undefined
}

export const AMBASSADOR_CHANNELS: { [key: string]: { text: string; detailPlaceholder: string; detailLabel: string; } } = {
  instagram: {
    text: 'instagram',
    detailPlaceholder: 'instagram_placeholder',
    detailLabel: 'username'
  },
  tiktok: {
    text: 'tiktok',
    detailPlaceholder: 'tiktok_placeholder',
    detailLabel: 'username'
  },
  blog: {
    text: 'blog',
    detailPlaceholder: 'blog_placeholder',
    detailLabel: 'url'
  },
  other: {
    text: 'other',
    detailPlaceholder: 'other_placeholder',
    detailLabel: 'channel_detail'
  },
}

export const AMBASSADOR_CHANNEL_OPTIONS = Object.keys(AMBASSADOR_CHANNELS).map((key) => {
  return {
    value: key,
    text: AMBASSADOR_CHANNELS[key].text,
  };
});

export const FILTER_TIME_RANGES = [
  'last_7_days',
  'last_30_days',
  'last_90_days',
  'last_month',
  'current_month',
  'all_time'
]

export const UNCAPPED_EARNING_NUM_OF_ORDERS = 3
